<template>
  <div v-wechat-title="$route.meta.title">
    <div v-if="pageShow">
      <div class="fix">
        <div class="back">
          <img @click="back" src="../assets/img/back.png" />
          <span>订单详情</span>
        </div>
      </div>
      <div style="height: .8rem"></div>
      <!-- <div class="orderTop van-hairline--bottom">
        <div>下单时间:{{ CreateTimeText }}</div>
        <div>{{ OrderTypeText }}:{{ SalesOrderCode }}</div>
        <div v-if="Remark">备注:{{ Remark }}</div>
      </div> -->
      <div class="topInfo">
        <div class="infoList">
          <div class="fl">{{ OrderTypeText }}单号: {{ SalesOrderCode }}</div>
          <div class="vin fr">VIN码：{{ vin }}</div>
        </div>
        <div class="infoList">
          <div class="fl date" v-if="isType==1">
            客户名称:{{ customerName }}
          </div>
          <div class="fr VehicleTypeName">
            {{ VehicleTypeName }}
          </div>
        </div>
        <div class="date">
            开单日期:{{ CreateTimeText }}
          </div>
        <div class="row">
          <div class="remark-box">
            <div class="remark">备注:{{ Remark || "无" }}</div>
          </div>
        </div>
        <div class="row">
          <div class="info-btn fr" @click="handleToPage">
            <van-button type="primary" size="mini">查看单据配送情况</van-button>
          </div>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="payStatus">
        <span>{{OrderTypeText}}</span>
        <span>{{SaleBillingnum>0?'已转结算':PayStatusText}}</span>
      </div>
      <div class="cont">
        <!-- <ul class="list asxnc">
          <li class="van-hairline--bottom" v-for="(item, idx) of list" :key="idx">
            <van-image
              class="img"
              :src="item.PicUrl ? item.PicUrl : require('../assets/pingzi/zhanweitu@2x.png')"
              fit="contain"
            >
              <template v-slot:error>
                <img :src="require('../assets/pingzi/zhanweitu@2x.png')" />
              </template>
            </van-image>
            <div class="liCont">
              <div class="van-multi-ellipsis--l2 title">{{ item.ProductTitle }}</div>
              <div class="nums">
                <div class="noit">
                  <div>单价:￥{{ item.Price | toFixedNum }}</div>
                  <div>数量:{{ item.CountNum }}</div>
                </div>
                <div class="Amount">￥{{ sigleAmount(item.Price, item.CountNum) }}</div>
              </div>
            </div>
          </li>
        </ul> -->
        <!-- <SimpleTableGroupList class="groupList" :service="{ tables: OrderDetailStore.tables }" :types="listUrl" /> -->
        <div class="listRow">

          <div class="lists" v-for="(item, index) in this.list" :key="index">
            <h1>
              {{item.ProductName}}
              <span v-if="item.LocationName">货位：{{item.LocationName}}</span>
              <span>品牌：{{item.BrandName}}</span>
            </h1>
            <div>
              <div class="row1">
                <span>型号：{{item.Model}}</span>
                <span class="text" v-if="item.BrandManufacturerCode">厂商编码：{{ item.BrandManufacturerCode }}</span>
                <span class="text">规格：{{ item.Spec||'无' }}</span>
                
              </div>
              <div class="row2">
                <span>数量：{{item.Num}}</span>
                <span>单价：{{item.Price}}</span>
                <span>金额：<b style="color:red;font-weight:normal">{{item.Amount}}</b></span>
              </div>
            </div>
          </div>

        </div>
      </div>
      <footer class="footer van-hairline--top">
        <div class="top">
          <div class="num">合计数量：{{ num }}</div>
          <div class="Amount">
            <span>合计金额：</span>
            <span>￥{{ amount }}</span>
          </div>
        </div>
        <div class="shareBtn" @click="isShare = true" v-if="payStatus==1&&isType==1&&SaleBillingnum==0"><van-button type="primary">转发给客户付款</van-button></div>
        <div class="shareBtn" v-if="payStatus==1&&isType==2&&shareType==1&&SaleBillingnum==0"><van-button type="primary" @click="pay()">支付</van-button></div>
      </footer>
      <template v-if="isShare">
        <div class="fixed-layer"></div>
        <div class="sharebg" @click="isShare = false"></div>
      </template>
      <!-- loading的显示隐藏 -->
      <van-popup :close-on-click-overlay="false" v-model="loadShow">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </van-popup>
      <!-- 选择支付方式 -->
      <paytype ref="pay" @paySuccess="paySuccess" @cancelPay="cancelPay"></paytype>
    </div>
    
  </div>
</template>
<script>
import Vue from "vue";
import api from "../services/api";
import util from "../utils/util";
import { Toast, Image as VanImage } from "vant";
import SimpleTable from "../components/table/SimpleTable";
import { buildImgSrc } from "../services/buyCar";
import OrderDetailStore from "../store/OrderDetail";
import SimpleTableGroupList from "../components/list/SimpleTableGroupList";
import OrderDetail from "../store/OrderDetail";
import paytype from "../components/paytype";

Vue.use(VanImage);
export default {
  name: "orderDetail",
  components: { SimpleTable, SimpleTableGroupList, paytype },
  data() {
    return {
      OrderDetailStore,
      pageShow: false,
      SalesOrderCode: "",
      CreateTimeText: "",
      OrderTypeText: "",
      list: [],
      Remark: "",
      vin: "",
      VehicleTypeName: "",
      listUrl:'orderDetail',
      PayStatusText:"",
      payStatus:0,
      isShare:false,
      isType:1,
      customerName:"",
      shareType:0,//1=员工分享出来的订单详情
      loadShow:false,
      disabledPayCredit: false, //是否有活动
      orderInfo:{},
      SaleBillingnum:0//是否是结算单
    };
  },
  filters: {
    toFixedNum(val) {
      return Number(val).toFixed(2);
    },
  },
  computed: {
    // 合计数量
    num() {
      let num = 0;
      this.list.map((it) => {
        num = num + it.CountNum;
      });
      return num;
    },
    // 合计金额
    amount() {
      let amount = 0;
      this.list.map((it) => {
        amount = amount + it.Price * it.CountNum;
      });
      return Number(amount).toFixed(2);
    },
    // 单据金额
    sigleAmount() {
      return function(num, amount) {
        return Number(num * amount).toFixed(2);
      };
    },
  },
  created() {
    this.getData(this.$route.params.id);
    this.isType = util.getStoObj('urlQuery').IsTypr;
    if(this.$route.query.customerName&&this.isType==2){
      sessionStorage.setItem("CustomerName", this.$route.query.customerName);
    }
    if( (this.isType==1) || (this.isType==2&&sessionStorage.getItem("CustomerName")) ){
      this.customerName = sessionStorage.getItem("CustomerName");
    }
    if(this.$route.query.shareType){
      this.shareType = this.$route.query.shareType;
    }
    
  },
  mounted(){
    wx.miniProgram.postMessage({
      data: {
        shareUrl: "orderDetail/"+this.$route.params.id,
        shareTitle: "订单详情",
        payStatus: this.payStatus,
        shareType:this.isType,
        customerName:this.customerName,
        RobotCode:util.getStoObj("urlQuery").RobotCode,
        VehicleTypeId:util.getStoObj("urlQuery").VehicleTypeId,
        Vin:util.getStoObj("urlQuery").Vin,
        carTypeName:decodeURIComponent(util.getStoObj("urlQuery").carTypeName||''),
        Eshop_DMSCode:util.getStoObj("urlQuery").Eshop_DMSCode,
        customerMobile:localStorage.getItem("EmployeeMobile"),
        customerId: localStorage.getItem("CustomerID")
      }
    });
  },
  methods: {
    back() {
      //this.$router.go(-1);
      this.$router.push({
        path: "/"
      });
    },
    pay(){
      this.$refs.pay.show({
        OrderId: this.orderInfo.Id,
        OrderCode: this.orderInfo.SalesOrderCode,
        OrderType: this.orderInfo.OrderType,
        Amount: this.orderInfo.Amount,
        uiType: "full",
        hideItems: this.disabledPayCredit ? ["limit"] : [], //非活动订单
        enableCoupon: !this.disabledPayCredit, //非活动订单
        Type: 63,//如果有值(出库的时候type传20)，结算单，否则：销售开
        Id: this.orderInfo.Id,//出库的时候要传的ID值
      });
    },
    cancelPay() {
      console.log("用户取消支付了");
      this.$router.replace(`/orderDetail/${this.orderInfo.Id}`);
    },
    paySuccess() {
      console.log("支付成功");
      this.$router.replace({
        path: "/paySuccess",
        query: {
          id: this.orderInfo.Id,
          ordertype: this.orderInfo.OrderType === 20 ? 1 : 2 /**20 销售结算 43销售开单***/,
          type: this.orderInfo.OrderType,
          isSeckill: this.isSeckill,
        },
      });
    },
    async getData(id) {
      const imgUrl = util.getStoObj("allinfo").DomainUrl;
      const loading = Toast.loading({ message: "加载中...", duration: 0 });
      try {
        let res = await api.historicalOrder({ SalesOrderID: id });
        if (res.ResultType == 1) {
          res.Data = res.Data[0] || {};
          this.orderInfo = res.Data;
          this.SalesOrderCode = res.Data.SalesOrderCode;
          this.CreateTimeText = res.Data.CreateTimeText;
          this.OrderTypeText = res.Data.OrderTypeText;
          this.Remark = res.Data.Remark;
          this.vin = res.Data.vin;
          this.VehicleTypeName = res.Data.VehicleTypeName;
          this.PayStatusText = res.Data.PayStatusText;
          this.payStatus = res.Data.PayStatus;
          this.SaleBillingnum = res.Data.SaleBillingnum;
          res.Data.SalesOrderItemList = res.Data.SalesOrderItemList || [];
          if (res.Data.SalesOrderItemList.length > 0) {
            res.Data.SalesOrderItemList.map((it) => {
              it = buildImgSrc(it);
              it.Amount = Number(it.CountNum * it.Price).toFixed(2);
            });
          }
          this.list = res.Data.SalesOrderItemList;
          OrderDetail.initTablesGroupBy({
            list: this.list,
            field: "ClassificationName",
          });
          console.log(OrderDetailStore.tables);
          console.log(this.list);
          if(this.shareType==1&&this.isType==2&&this.payStatus==1){

          }
        }

        this.pageShow = true;
        loading.clear();
      } catch {
        this.pageShow = true;
        loading.clear();
      }
    },
    handleToPage() {
      this.$router.push("/baojia");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/orderDetail.scss";
.cont {
  margin-bottom: 1.5rem;
}
.shareBtn{
  width: 100%;
  height: 44px;
  button{
    width: 100%;
    vertical-align: top;
  }
}
.fixed-layer {
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 1;
    -webkit-transition-duration: .3s;
    transition-duration: .3s;
    background: rgba(0, 0, 0, .4);
    z-index: 1000;
}
.sharebg {
    background: url(../assets/icon/share_bg.png) no-repeat right 0;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1001;
    top: 0;
    right: 1rem;
    display: block;
    background-size: 80% auto;
    z-index: 1000;
}
.listRow{
  font-size: 0.2rem;
  padding: 10px;
  .lists{
    margin-bottom: 10px;
    background: #fff;
  }
  h1{
    font-size: 0.2rem;
    padding: 5px;
    display: flex;
    justify-content:space-between;
    span{
      font-weight: normal;
    }
  }
  .row1{
    display: flex;
    // justify-content: space-between;
    span{
      width: 50%;
      padding: 5px;
    }
  }
  .row2{
    display: flex;
    background: #eee;
    span{
      width: 33.3333%;
      padding: 5px;
    }
  }
}
.payStatus{
  font-size: 0.24rem;
  display: flex;
  justify-content: space-between;
  padding:10px 10px 0px 10px;
}
.topInfo {
  font-size: 0.28rem;
  background: #fff;
  padding: 0.1rem 0.2rem;
  line-height: 0.42rem;
  .infoList{
    display: flex;
    font-size:.2rem;
    justify-content: space-between;
    .fr{text-align: right;}
  }
  .row:first-child {
    border-bottom: 1px #f2f2f2 solid;
    color: #666;
  }
  .icon.date {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 1.5em;
    height: 1em;
    vertical-align: text-top;
    display: inline-block;
    background-image: url(../assets/shengji/date.png);
  }
  .row {
    .VehicleTypeName {
      color: #555;
    }
    .remark-box {
      display: flex;
      .remark {
        flex: 1;
        font-size: 0.18rem;
        color: #666;
      }
    }
  }
  .row.flex {
    display: flex;
    .date {
      text-align: right;
    }
  }
  .row.flex > div {
    flex: 1;
  }
}
</style>
<style>
.asxnc .van-image__error {
  position: static !important;
}
</style>
